import React, { useState, useEffect } from 'react'

// Custom Toast notification system with fallback

// Fallback para toast se ReactToastify não estiver disponível
let toast, ToastContainer;

// Espera um pouco pelo ReactToastify se ainda estiver carregando
const initToastify = () => {
    if (window.ReactToastify && window.ReactToastify.toast) {
        ({ toast, ToastContainer } = window.ReactToastify);
        return true;
    }
    return false;
};

if (!initToastify()) {
    // Fallback com implementação custom elegante
    const toastNotifications = [];
    let notificationListeners = [];

    toast = {
        success: (msg) => {

            showCustomToast(msg, 'success');
        },
        error: (msg) => {

            showCustomToast(msg, 'error');
        },
        warning: (msg) => {

            showCustomToast(msg, 'warning');
        },
        info: (msg) => {

            showCustomToast(msg, 'info');
        },
        confirm: (msg, onConfirm, onCancel) => {

            showConfirmToast(msg, onConfirm, onCancel);
        },
    };

    const showCustomToast = (msg, type) => {
        const id = Date.now();
        const notification = { id, msg, type };
        toastNotifications.push(notification);
        notificationListeners.forEach(listener => listener());
        setTimeout(() => {
            const index = toastNotifications.findIndex(n => n.id === id);
            if (index > -1) {
                toastNotifications.splice(index, 1);
                notificationListeners.forEach(listener => listener());
            }
        }, 4000);
    };

    const showConfirmToast = (msg, onConfirm, onCancel) => {
        const id = Date.now();
        const notification = { id, msg, type: 'confirm', onConfirm, onCancel };
        toastNotifications.push(notification);
        notificationListeners.forEach(listener => listener());
        // Don't auto-dismiss confirmation toasts
    };

    ToastContainer = () => {
        const [notifications, setNotifications] = useState([]);

        useEffect(() => {
            const listener = () => setNotifications([...toastNotifications]);
            notificationListeners.push(listener);
            setNotifications([...toastNotifications]);
            return () => {
                notificationListeners = notificationListeners.filter(l => l !== listener);
            };
        }, []);

        const getIcon = (type) => {
            if (type === 'success') {
                return <span className="material-icons sm text-green-500">check_circle</span>;
            } else if (type === 'error') {
                return <span className="material-icons sm text-red-500">cancel</span>;
            } else if (type === 'warning') {
                return <span className="material-icons sm text-amber-500">warning</span>;
            } else {
                return <span className="material-icons sm text-blue-500">info</span>;
            }
        };

        const getStyles = (type) => {
            switch (type) {
                case 'success':
                    return {
                        bg: 'bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-950/40 dark:to-emerald-950/40',
                        border: 'border-green-200 dark:border-green-900/50',
                        text: 'text-green-900 dark:text-green-200',
                        progressBg: 'bg-gradient-to-r from-green-400 to-emerald-500'
                    };
                case 'error':
                    return {
                        bg: 'bg-gradient-to-r from-red-50 to-rose-50 dark:from-red-950/40 dark:to-rose-950/40',
                        border: 'border-red-200 dark:border-red-900/50',
                        text: 'text-red-900 dark:text-red-200',
                        progressBg: 'bg-gradient-to-r from-red-400 to-rose-500'
                    };
                case 'warning':
                    return {
                        bg: 'bg-gradient-to-r from-amber-50 to-yellow-50 dark:from-amber-950/40 dark:to-yellow-950/40',
                        border: 'border-amber-200 dark:border-amber-900/50',
                        text: 'text-amber-900 dark:text-amber-200',
                        progressBg: 'bg-gradient-to-r from-amber-400 to-yellow-500'
                    };
                default:
                    return {
                        bg: 'bg-gradient-to-r from-blue-50 to-cyan-50 dark:from-blue-950/40 dark:to-cyan-950/40',
                        border: 'border-blue-200 dark:border-blue-900/50',
                        text: 'text-blue-900 dark:text-blue-200',
                        progressBg: 'bg-gradient-to-r from-blue-400 to-cyan-500'
                    };
            }
        };

        return (
            <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3 max-w-sm pointer-events-none">
                {notifications.map((n, idx) => {
                    const styles = getStyles(n.type);
                    return (
                        <div
                            key={n.id}
                            className={`
                                pointer-events-auto
                                ${styles.bg}
                                border ${styles.border}
                                rounded-xl
                                p-4
                                shadow-xl
                                backdrop-blur-md
                                overflow-hidden
                                animate-in slide-in-from-bottom-4 fade-in duration-300
                            `}
                            style={{
                                animationDelay: `${idx * 50}ms`
                            }}
                        >
                            <div className="flex items-start gap-3 mb-3">
                                <div className="flex-shrink-0 mt-0.5">
                                    {getIcon(n.type)}
                                </div>
                                <div className="flex-1 min-w-0">
                                    <p className={`text-sm font-medium ${styles.text} break-words`}>
                                        {n.msg}
                                    </p>
                                </div>
                            </div>
                            {n.type === 'confirm' ? (
                                <div className="flex gap-2 pt-3">
                                    <button
                                        onClick={() => {
                                            n.onConfirm && n.onConfirm();
                                            const index = toastNotifications.findIndex(notif => notif.id === n.id);
                                            if (index > -1) {
                                                toastNotifications.splice(index, 1);
                                                notificationListeners.forEach(listener => listener());
                                            }
                                        }}
                                        className="flex-1 px-3 py-1.5 font-medium text-sm transition bg-white dark:bg-gray-800 border border-blue-500 hover:border-blue-600 text-blue-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-300 dark:border-blue-400 rounded-lg"
                                    >
                                        OK
                                    </button>
                                    <button
                                        onClick={() => {
                                            n.onCancel && n.onCancel();
                                            const index = toastNotifications.findIndex(notif => notif.id === n.id);
                                            if (index > -1) {
                                                toastNotifications.splice(index, 1);
                                                notificationListeners.forEach(listener => listener());
                                            }
                                        }}
                                        className="flex-1 px-3 py-1.5 font-medium text-sm transition bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 hover:border-gray-400 dark:hover:border-gray-500 text-gray-900 dark:text-gray-100 rounded-lg"
                                    >
                                        Cancelar
                                    </button>
                                </div>
                            ) : (
                                <div className="w-full h-1 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
                                    <div
                                        className={`h-full ${styles.progressBg}`}
                                        style={{
                                            animation: 'shrink 4s linear forwards'
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        );
    };
}

// Adiciona animação de shrink
if (!document.getElementById('toast-styles')) {
    const style = document.createElement('style');
    style.id = 'toast-styles';
    style.textContent = `
        @keyframes shrink {
            from { width: 100%; }
            to { width: 0%; }
        }
        @keyframes slide-in-from-bottom-4 {
            from {
                opacity: 0;
                transform: translateY(16px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }
        @keyframes fade-in {
            from { opacity: 0; }
            to { opacity: 1; }
        }
    `;
    document.head.appendChild(style);
}

export { toast, ToastContainer, initToastify }
